/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_References_Tools_Admin_Disabled_ShortInputs */



/**
* | output |
* | --- |
* | "Disabled by your admin" |
*
* @param {Project_References_Tools_Admin_Disabled_ShortInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_references_tools_admin_disabled_short = /** @type {((inputs?: Project_References_Tools_Admin_Disabled_ShortInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_References_Tools_Admin_Disabled_ShortInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Von der Administration deaktiviert")
	return /** @type {LocalizedString} */ ("Disabled by your admin")
});